import { Component, ElementRef, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Gesture }  from 'ionic-angular';
declare var Hammer: any;

// const ALLOWED_POSITIONS = ['top', 'bottom', 'left', 'right'];

@Component({
  selector: '[dra-menu]',
  template: `
<ng-content></ng-content>
<button class="toggle-handle" ion-button icon-only color="dark" (click)="toggle()">
  <ion-icon name="menu"></ion-icon>
</button>
`
})
export class DraMenuComponent implements OnInit, OnDestroy {
  @Input('side') side: string;
  @Output('dra-menu') onClose: EventEmitter<any> = new EventEmitter();

  private element: HTMLElement;
  private swipeLength: number;
  private swipeGesture: Gesture;
  private verticalSwipe: boolean = false;
  private positiveSwipe: boolean;
  private opened: boolean = false;
  private threshold: number = 0.1;

  constructor(elementRef: ElementRef) {
    this.element = elementRef.nativeElement;
  }

  public ngOnInit() {
    this.side = this.side || 'left';
    if (['left', 'right'].indexOf(this.side) < 0) return console.error('Invalid direction');
    this.positiveSwipe = (this.side == 'left');
    this.element.classList.add('dra-menu');
    this.element.classList.add(`dra-menu-${this.side}`);

    this.swipeLength = this.element.getBoundingClientRect().width;

    this.swipeGesture = new Gesture(this.element, {
      recognizers: [
        [Hammer.Pan, {direction: Hammer.DIRECTION_HORIZONTAL}]
      ]
    });
    this.swipeGesture.listen();
    // this.swipeGesture.on('panstart', e => this.onSwipeStart(e));
    this.swipeGesture.on('panmove', e => this.onSwipe(e));
    this.swipeGesture.on('panend', e => this.onSwipeEnd(e));
  }
  public ngOnDestroy() {
    this.swipeGesture.destroy();
  }
  public onSwipe($event) {
    if (!this.verticalSwipe && window.innerWidth > 991) return;

    let moved: number = this.movedDistance($event, this.swipeLength);

    // console.log(moved);
    if (this.verticalSwipe) {
      this.element.style.top = (this.positiveSwipe ? moved : -moved) + 'px';
    } else {
      if (this.positiveSwipe) {
        this.element.style.left = (this.opened ? -moved : -this.swipeLength + moved) + 'px';
      } else {
        this.element.style.right = (this.opened ? -moved : - this.swipeLength + moved) + 'px';
      }
        // this.element.style.right = (this.positiveSwipe === this.opened ? moved : Math.max((this.swipeLength - moved), 0)) + 'px';
        // this.element.style.right = (moved) + 'px';
    }
    this.element.style.transition = 'none';
  }
  public onSwipeEnd($event) {
    let moved: number = this.movedDistance($event),
      percent: number = (this.swipeLength - moved) / this.swipeLength;

    if (percent < 1 - this.threshold) {
      this.toggle();
      this.onClose.emit($event);
    } else {
    }
    this.element.style.transition = '';
    this.element.style.left = '';
    this.element.style.right = '';
  }
  toggle() {
    this.opened = !this.opened;
    if (this.opened) {
      this.element.classList.add('open');
    } else {
      this.element.classList.toggle('open');
    }
  }

  private movedDistance($event, max?: number): number {
    let moved = this.verticalSwipe ? $event.deltaY : $event.deltaX;
    moved = Math.max((this.positiveSwipe !== this.opened) ? moved : -moved, 0);
    return max ? Math.min(moved, max) : moved;
    // if (this.positiveSwipe) {
    //   return Math.max((this.opened) ? -moved : moved, 0);
    // } else {
    //   return Math.max((this.opened) ? moved : -moved, 0);
    // }
  }
}

/*

positive  opened    delta
true      false     true
true      true      false
false     false     false
false     true      true

 */



// WEBPACK FOOTER //
// ./src/directives/dra-menu.component.ts